export default __webpack_public_path__ + "static/media/bg_login.527e95ff.jpg";